import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

/** Estado vacío: ícono, título corto, una línea de ayuda y (opcional) la acción principal. */
export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  className,
  compact,
}: {
  icon: LucideIcon;
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  className?: string;
  /** Menos aire, para usar dentro de una card o lista. */
  compact?: boolean;
}) {
  return (
    <div className={cn('flex flex-col items-center gap-2 text-center', compact ? 'px-4 py-6' : 'px-4 py-12', className)}>
      <span
        className={cn(
          'mb-1 flex items-center justify-center rounded-full bg-muted text-muted-foreground',
          compact ? 'size-10' : 'size-12',
        )}
      >
        <Icon className={compact ? 'size-5' : 'size-6'} />
      </span>
      <p className="font-medium">{title}</p>
      {description && <p className="max-w-sm text-sm text-muted-foreground">{description}</p>}
      {action && <div className="mt-2 flex flex-wrap justify-center gap-2">{action}</div>}
    </div>
  );
}
